import $http from '../../axios';
import {Notification} from 'element-ui';

/**
 * Obtener ordenes de producción.
 */
export async function fetchProductionOrders({commit, state}) {

    commit('setPreloader', true);

    await $http.get('/api/ordenes-produccion', {params: state.filters})
        .then((response) => {
            commit('setProductionOrders', response.data.data);
            commit('setPreloader', false);
        })
        .catch(async (error) => {
            commit('setPreloader', false);

            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        });
}

/**
 * Obtener ordenes de producción.
 */
export async function fetchProductionOrder({commit, state}, id) {

    commit('setPreloader', true);

    await $http.get(`/api/ordenes-produccion/${id}`)
        .then((response) => {
            commit('setProductionOrder', response.data.data);
            commit('setContacts', [response.data.data.contact]);
            commit('setProducts', [response.data.data.finished_product]);
            commit('setPreloader', false);
        })
        .catch((error) => {
            commit('setPreloader', false);

            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        });
}

/**
 * Guardar orden de producción.
 */
export async function saveProductionOrder({commit, state}) {
    return new Promise(async (resolve, reject) => {

        commit('setPreloader', true);

        await $http.post('/api/ordenes-produccion', state.production_order)
            .then((response) => {
                commit('setProductionOrder', response.data.data);

                commit('setPreloader', false);

                Notification.success({
                    title: 'Muy bien',
                    message: response.data.message,
                    type: 'success',
                    duration: 2000,
                    customClass: 'notification-box',
                });

                resolve(response.data.data);
            })
            .catch(async (error) => {
                commit('setPreloader', false);

                await Notification.error({
                    title: 'Error!',
                    message: error.message,
                    type: 'error',
                    duration: 2000,
                    customClass: 'notification-box',
                });

                reject();
            });

    });
}


/**
 * Crear operación.
 */
export async function createOperation({commit, state}) {
    return new Promise(async (resolve, reject) => {

        commit('setPreloader', true);

        await $http.post(`/api/ordenes-produccion/operacion/${state.production_order.id}`, state.production_order)
            .then((response) => {
                commit('setPreloader', false);

                Notification.success({
                    title: 'Muy bien',
                    message: response.data.message,
                    type: 'success',
                    duration: 2000,
                    customClass: 'notification-box',
                });


                resolve();
            })
            .catch(async (error) => {
                commit('setPreloader', false);

                await Notification.error({
                    title: 'Error!',
                    message: error.response.data.message,
                    type: 'error',
                    duration: 2000,
                    customClass: 'notification-box',
                });

                reject();
            });

    });
}

/**
 * Cerrar orden de producción.
 */
export async function closeProductionOrder({commit, state}) {
    return new Promise(async (resolve, reject) => {

        commit('setPreloader', true);

        await $http.post(`/api/ordenes-produccion/cerrar/${state.production_order.id}`)
            .then((response) => {
                commit('setPreloader', false);

                Notification.success({
                    title: 'Muy bien',
                    message: response.data.message,
                    type: 'success',
                    duration: 2000,
                    customClass: 'notification-box',
                });

                resolve();
            })
            .catch(async (error) => {
                commit('setPreloader', false);

                await Notification.error({
                    title: 'Error!',
                    message: error.message,
                    type: 'error',
                    duration: 2000,
                    customClass: 'notification-box',
                });

                reject();
            });
    });
}

/**
 * Crear operación.
 */
export async function createOperationProduction({commit, state}) {
    return new Promise(async (resolve, reject) => {

        commit('setPreloader', true);

        await $http.post(`/api/ordenes-produccion/operacion-produccion/${state.production_order.id}`, state.production_order)
            .then((response) => {

                commit('setPreloader', false);

                Notification.success({
                    title: 'Muy bien',
                    message: response.data.message,
                    type: 'success',
                    duration: 2000,
                    customClass: 'notification-box',
                });

                resolve();
            })
            .catch(async (error) => {

                commit('setPreloader', false);

                await Notification.error({
                    title: 'Error!',
                    message: error.message,
                    type: 'error',
                    duration: 2000,
                    customClass: 'notification-box',
                });

                reject();
            });

    });
}

/**
 * Crear operación.
 */
export async function createOperationExit({commit, state}) {
    return new Promise(async (resolve, reject) => {

        commit('setPreloader', true);

        await $http.post(`/api/ordenes-produccion/operacion-consumo/${state.production_order.id}`, state.production_order)
            .then((response) => {
                commit('setPreloader', false);

                Notification.success({
                    title: 'Muy bien',
                    message: response.data.message,
                    type: 'success',
                    duration: 2000,
                    customClass: 'notification-box',
                });

                resolve();
            })
            .catch(async (error) => {
                commit('setPreloader', false);

                await Notification.error({
                    title: 'Error!',
                    message: error.message,
                    type: 'error',
                    duration: 2000,
                    customClass: 'notification-box',
                });

                reject();
            });

    });
}

/**
 * Obtener terceros.
 */
export async function fetchContacts({commit, state}, filter) {
    if (filter.length >= 3) {
        let params = {
            filter: filter,
            type: 'is_provider',
            paginate: false
        };

        commit('setPreloader', true);

        await $http.get('/api/terceros', {params})
            .then((response) => {
                commit('setContacts', response.data.data);

                commit('setPreloader', false);
            })
            .catch((error) => {
                commit('setPreloader', false);

                Notification.error({
                    title: 'Error!',
                    message: error.message,
                    type: 'error',
                    duration: 1500,
                    customClass: 'notification-box',
                });
            });
    }
}

/**
 * Obtener productos.
 */
export async function fetchProducts({commit, state}, filter) {
    if (filter.length >= 3) {
        let params = {
            filter: filter,
            states: [true]
        };

        commit('setPreloader', true);

        await $http.get('/api/listar-productos', {params})
            .then((response) => {
                commit('setProducts', response.data.data);
                commit('setPreloader', false);
            })
            .catch((error) => {
                commit('setPreloader', false);

                Notification.error({
                    title: 'Error!',
                    message: error.message,
                    type: 'error',
                    duration: 1500,
                    customClass: 'notification-box',
                });
            });
    }
}

export async function fetchLots({commit, state}, document_product) {
    commit('setLots', []);

    let params = {
        params: {
            branchoffice_id: state.branch_office_main.id,
            branchoffice_warehouse_id: document_product.branch_office_warehouse_exit_id
        }
    };

    commit('setPreloader', true);

    await $http
        .get(`/api/inventario-lotes-por-producto/${document_product.product.id}`, params)
        .then(response => {
            commit('setLots', response.data);
            commit('setPreloader', false);
        })
        .catch(error => {
            commit('setPreloader', false);

            Notification.error({
                title: '¡Error!',
                message: 'Error al obtener los lotes',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

/**
 * Obtener operaciones.
 */
export async function fetchOperations({commit, state, dispatch}) {
    if (!state.operations.length) {
        await dispatch('fetchParameters', 'OPEOP')
            .then(operations => commit('setOperations', operations))
            .catch(error => console.error(error));
    }
}


/**
 * Obtener estados.
 */
export async function fetchStates({commit, state, dispatch}) {
    if (!state.states.length) {
        await dispatch('fetchParameters', 'OPETE')
            .then(states => commit('setStates', states))
            .catch(error => console.error(error));
    }
}

/**
 * Obtener parametros.
 */
export async function fetchParameters({commit, state}, code) {
    return new Promise(async (resolve, reject) => {

        commit('setPreloader', true);

        await $http.get(`/api/parametros-por-codigo/${code}`)
            .then((response) => {
                commit('setPreloader', false);
                resolve(response.data.data);
            })
            .catch((error) => {
                commit('setPreloader', false);
                reject(error);
            });
    });
}


/**
 * Obtener sede principal.
 */
export async function fetchBranchOfficeMain({commit, state}) {
    if (!state.branch_office_main) {

        commit('setPreloader', true);

        await $http.get(`/api/sede-por-codigo/102`)
            .then((response) => {
                commit('setBranchOfficeMain', response.data.data);
                commit('setPreloader', false);
            })
            .catch((error) => {
                commit('setPreloader', false);
                console.error(error);
            });
    }
}

/**
 * Obtener sede.
 */
export async function fetchBranchOfficeWarehouse({commit, state}, code) {
    return new Promise(async (resolve, reject) => {

        commit('setPreloader', true);

        await $http.get(`/api/bodega-por-codigo/${code}/${state.branch_office_main.id}`)
            .then((response) => {
                commit('setPreloader', false);
                resolve(response.data.data);
            })
            .catch((error) => {
                commit('setPreloader', false);
                reject(error);
            });
    });
}

/**
 * Obtener sede disponible.
 */
export async function fetchBranchOfficeWarehouseAvailable({commit, dispatch}) {
    await dispatch('fetchBranchOfficeWarehouse', '01')
        .then(branch_office_warehouse => commit('setBranchOfficeWarehouseAvailable', branch_office_warehouse))
        .catch(error => console.error(error));
}

/**
 * Obtener sede acondicionamiento.
 */
export async function fetchBranchOfficeWarehouseConditioning({commit, dispatch}) {
    await dispatch('fetchBranchOfficeWarehouse', '02')
        .then(branch_office_warehouse => commit('setBranchOfficeWarehouseConditioning', branch_office_warehouse))
        .catch(error => console.error(error));
}

export async function generatePdf({commit, state}, id) {

    commit('setPreloader', true);

    await $http({
        url: `/api/traslado/descargar-pdf/${id}`,
        method: 'GET',
        responseType: 'blob' // important
    })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Traslado.pdf'); //or any other extension
            document.body.appendChild(link);
            link.click();

            commit('setPreloader', false);
        })
        .catch(error => {
            commit('setPreloader', false);
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });

        });
}

export async function generatePdfProductionOrder({commit, state}) {

    commit('setPreloader', true);

    await $http.get(`/api/pdf-acondicionamiento/${state.production_order.id}`)
        .then((response) => {
            commit('setPdf', response.data);
            commit('setPreloader', false);
        })
        .catch((error) => {
            commit('setPreloader', false);
            console.error(error);
        });
}

/**
 * Obtener bodegas de la sede principal.
 */
export async function fetchBranchOfficeWarehouses({commit, state}) {

    if (!state.branch_offices_warehouses.length) {

        commit('setPreloader', true);

        let params = {
            branchoffice_id: state.branch_office_main.id
        };

        await $http.get(`/api/bodegas-sedes`, {params})
            .then((response) => {
                commit('setBranchOfficeWarehouses', response.data.data);
                commit('setPreloader', false);
            })
            .catch((error) => {
                console.error(error);
                commit('setPreloader', false);
            });
    }
}



// WEBPACK FOOTER //
// ./src/modules/conditioning/actions.js